"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.selectTutorialConfig = exports.selectPrivacyPolicyConfig = void 0;
var selectPrivacyPolicyConfig = function (_a) {
    var participantConfigs = _a.participantConfigs;
    return participantConfigs.data.privacyPolicy;
};
exports.selectPrivacyPolicyConfig = selectPrivacyPolicyConfig;
var selectTutorialConfig = function (_a) {
    var participantConfigs = _a.participantConfigs;
    return participantConfigs.data.tutorial;
};
exports.selectTutorialConfig = selectTutorialConfig;
//# sourceMappingURL=participantConfigs.selectors.js.map